import { PLACE_COORDS } from "@/lib/countryCoords";
import { isoForPlace } from "@/lib/countryCodes";

export type LuoghiRisolti = {
  /** Codici ISO 3166-1 alpha-2 dei Paesi citati (guidano il choropleth). */
  mentionedISO: string[];
  /** Nomi citati che non sono né Paesi né luoghi noti: la mappa li
   *  elenca sotto di sé come "Altri luoghi citati". */
  unresolved: string[];
};

/**
 * Dai luoghi di un dispaccio ai Paesi che la mappa sa disegnare.
 * "EU"/"Europa" mappano al codice sintetico `EU`: nessun poligono
 * singolo, li saltiamo.
 *
 * Sta in `lib/` e non dentro `ArticleMap.tsx` perché serve a due
 * componenti diversi e uno solo dei due può permettersi di tirarsi
 * dietro maplibre: il guscio della mappa (`ArticleMapLazy`) deve sapere
 * quanti paesi ci sono per scrivere la testata e decidere se rendere
 * qualcosa, e lo deve sapere *prima* di montare la tela.
 */
export function risolviLuoghi(places: string[]): LuoghiRisolti {
  const isoSet = new Set<string>();
  const missing: string[] = [];
  for (const name of places) {
    const iso = isoForPlace(name);
    if (iso && iso.length === 2 && iso !== "EU") {
      isoSet.add(iso);
      continue;
    }
    // Non è un Paese e nemmeno un luogo geolocalizzato a noi noto.
    if (!iso && !PLACE_COORDS[name]) missing.push(name);
  }
  return { unresolved: missing, mentionedISO: Array.from(isoSet) };
}
